import type { Me } from '../auth/authApi.ts';
import type { AdminPage } from '../lib/router.ts';
import { AdminHealthView } from './AdminHealthView.tsx';
import { AdminRunsView } from './AdminRunsView.tsx';
import { AdminUsersView } from './AdminUsersView.tsx';
import { PlaceholderView } from './PlaceholderView.tsx';

/**
 * The one place the role decides what an admin hash renders (docs/specs/accounts.md, sections 8
 * and 9). For a person who is not an admin the admin pages do not exist: the server answers their
 * requests with a 404, and the page says the same thing. No admin view mounts for them, so no
 * admin request is even made.
 */
export function AdminRoute({ page, me }: { page: AdminPage; me: Me }): JSX.Element {
  if (me.role !== 'admin') return <PlaceholderView label="not found" text="This page does not exist." />;
  switch (page) {
    case 'users':
      return <AdminUsersView me={me} />;
    case 'runs':
      return <AdminRunsView />;
    case 'health':
      return <AdminHealthView />;
  }
}
